<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="Citrin_CS1_3_1d03"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import Citrin_CS1_3_1d03 from '@/device-products/Citrin_CS1_3_1d03.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
      {
        label: 'GP', connections: [
        ],
      },
    ],
    simulationDevices: [
      { id: 0, component: Citrin_CS1_3_1d03, deviceLabel: null },
    ],
  }),
};
</script>

<style>

</style>
